import React, { useState, useEffect, useReducer } from 'react';
import { Link, useParams } from 'react-router-dom'
import Header from '../../header/Header'
import Footer from '../../footer/Footer'
import Area from './area/Area';
import Cell from './cell/Cell';
import Line from './line/Line';

const AdminKaizen = props => {
    const { category, site, app } = useParams();
    const [animate, setAnimate] = useState('');

    useEffect(() => {
        setTimeout(() => {
            setAnimate('animate')
        }, 250);
    }, []);


    return (
        <>
            <Header showPinBtn={false} site={[]} />

            <section className="page-content">
                <div className="site-view tier-wrap admin-console-wrapper">
                    <div className={"site-list " + animate}>
                        <div className="breadcrumb">
                            <span className="icon icon-corporate"></span>
                            <ul>
                                <li><Link to={`/`}>Home</Link></li>
                                <li><Link to={`/siteApp/${category}/${site}/kaizen`}>Kaizen</Link></li>
                                <li><Link to={`/siteApp/${category}/${site}/kaizenAdmin`}>Admin</Link></li>
                                {app === "area" && <li>Area</li>}
                                {app === "cell" && <li>Cell</li>}
                                {app === "line" && <li>Line</li>}
                            </ul>
                        </div>

                        <div className="raiseci-section">
                            <div className="page-heading">
                                {app === "area" && <h2> <span className="icon karea" ></span> Area </h2>}
                                {app === "cell" && <h2> <span className="icon kcell" ></span> Cell </h2>}
                                {app === "line" && <h2> <span className="icon kline" ></span> Line </h2>}
                            </div>
                        </div>

                        {app === "area" && <Area category={category} site={site} app={app} />}
                        {app === "cell" && <Cell category={category} site={site} app={app} />}
                        {app === "line" && <Line category={category} site={site} app={app} />}

                    </div>
                </div>
            </section>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Footer showThemeSwitch={true} container="admin-console" hideSiteCount={true} activeSites={[]} sbg={[]} />
            </div>
        </>
    )
}

export default AdminKaizen